import { RailgunBase } from '../RailgunBase';
import { RailgunError } from '../RailgunError';

/**
 * BaseService
 *
 * サービスはBaseServiceを継承して作成するようにする
 */
export class BaseService extends RailgunBase {

	// Log/Error等は、railgunBaseにいる

	// 呼び出したオブジェクトを持っておく
	private parentObj: RailgunBase;

	/**
	 * コンストラクタ
	 * @param parent 呼び出し元
	 */
	constructor(parent: RailgunBase) {
		super();
		// サービスを呼び出す親を持っておく
		this.parentObj = parent;
	}

	////////////////////////////////////////////
	// エラー関連の処理をオーバライドして、サービスに伝搬する

	/**
	 * getErrorObj
	 * エラーオブジェクトの取得
	 */
	public getErrorObj(): RailgunError {
		return this.parentObj.getErrorObj();
	}

	/**
	 * setErrorObj
	 * エラーオブジェクトの設定
	 */
	public setErrorObj(obj: RailgunError)  {
		this.parentObj.setErrorObj(obj);
	}



	// 指定文字以上の長文は指定文字+…に変換
	public getOmittion(text: string, count: number): string{
		if (text.length <= count) { return text;}
		return text.substring(0, count) + '…';
	}
}
